
import submitToFevirServer from './SubmitToFevirServer';

const loadNotificationNumbers = async (globalContext, flagNotificationBoolean = false) => {
    let body = {
        'functionid': 'getusernotificationnumbers',
        'idToken': ''
    };
    let response = await submitToFevirServer(globalContext, 30000, body, true, false);
    if (response?.success) {
        let newUnread = (globalContext.numberUnreadNotifications !== response.numberunreadnotifications);
        let newUncleared = (globalContext.numberUnclearedNotifications !== response.numberunclearednotifications);
            globalContext.setNumberUnreadNotifications(response.numberunreadnotifications);
        if (newUnread) {
        }
        if (newUncleared) {
            globalContext.setNumberUnclearedNotifications(response.numberunclearednotifications);
        }
    }
};

const loadNotifications = async (globalContext) => { //, flagNotificationBoolean = false
    let body = {
        'functionid': 'getusernotifications',
        'idToken': ''
    };
    let response = await submitToFevirServer(globalContext, 30000, body, true, false);
    if (response?.success) {
        let newUnread = (globalContext.numberUnreadNotifications !== response.numberunreadnotifications);
        let newUncleared = (globalContext.numberUnclearedNotifications !== response.numberunclearednotifications);
        if (newUnread) {
            globalContext.setNumberUnreadNotifications(response.numberunreadnotifications);
        }
        if (newUncleared) {
            globalContext.setNumberUnclearedNotifications(response.numberunclearednotifications);
        }
        /*
        if (flagNotificationBoolean && (newUnread || newUncleared)) {
            globalContext.setNewNotificationBoolean(true);
        }
        */
        let notifications = response.notifications || [];
        for (let notification of notifications) {
            //notification.time is a string by the time it's received on the client-side
            notification["timeString"] = (new Date(notification.time)).toLocaleString(undefined,    //"en-US"
                { weekday: 'short', year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric' } //weekday: 'long', month: 'long'
            );
        }
        return notifications;
    }
    return false;
};

export { loadNotifications, loadNotificationNumbers };